import styled, { css } from 'styled-components';

// FontAwesome.
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { xxsDevice } from '@exonet/react-shared/lib/styled';

export const Container = styled.span`
  display: flex;
  align-items: center;
  position: inherit;
  padding: inherit;
  top: inherit;
  left: inherit;
  background-color: inherit;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  padding-right: var(--lg-padding-horizontal);
  mask-image: linear-gradient(to right, black 90%, transparent 100%);

  scrollbar-width: none;
  -ms-overflow-style: none;

  ::-webkit-scrollbar {
    display: none;
  }
`;

export const Icon = styled(FontAwesomeIcon)`
  margin: 0 var(--xs-padding-horizontal);
  margin-bottom: -2px;

  ${xxsDevice(css`
    margin: 0 var(--xxs-padding-horizontal);
    margin-bottom: -2px;
  `)};
`;

export const Item = styled.span`
  display: flex;
  align-items: center;
  flex: 0 0 auto;

  &:first-child {
    > a {
      top: -1px;
    }
  }
`;
